import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, timer } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { Auth } from 'src/app/models/auth';
import { StatusBatch } from 'src/app/models/colaborador-batch';
import { saveAs } from 'file-saver';
import { PedidoService } from 'src/app/services/pedido.service';
import { PedidoDataService } from 'src/app/services/pedido-data.service';
import { StatusMinhasComprasList } from 'src/app/shared/enums/status-minhas-compras-list.enum';
import { ValuesPurchaseRequest } from 'src/app/models/purchase-values';

@Component({
  selector: 'app-nova-compra-arquivo-confirmar',
  templateUrl: './nova-compra-arquivo-confirmar.component.html',
  styleUrls: ['./nova-compra-arquivo-confirmar.component.css']
})
export class NovacompraArquivoConfirmarComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private pedidoDataService: PedidoDataService,
    private pedidoService: PedidoService,
    private alertService: NewAlertService,
    private authenticationService: AuthenticationService
  ) { }

  public currentUser: Auth;
  private id: number;
  private routeSubscription: Subscription;
  public sub: Subscription;
  public progressBarValue: number = 0;
  public status = new StatusBatch(0, 0, 0);
  public processed: boolean = false;
  public purchaseId: number;
  public StatusMinhasComprasList = StatusMinhasComprasList;
  public valuesPurchase = new ValuesPurchaseRequest();

  ngOnInit(): void {
    this.currentUser = this.authenticationService.currentUserValue;

    this.routeSubscription = this.route.paramMap.subscribe(params => {
      this.id = +params.get('id');

      if (this.id > 0) this.getStatus(this.id)
    });

    this.route.queryParamMap.subscribe(params => {
      if (params != null) {
        this.purchaseId = +params.get('purchase');
      }
    });
  }

  getStatus(id: any) {
    const options = {
      autoClose: true,
      keepAfterRouteChange: true
    };

    this.sub = timer(0, 5000).pipe(
      map(() => {
        this.pedidoService.getStatusBatch(id, this.currentUser.token.assignorGuid)
          .subscribe(
            response => {
              if (response.status == ApiError.Sucesso) {

                console.log(response.result)

                this.status = response.result;

                this.progressBarValue = (this.status.processada / this.status.total) * 100;

                if (this.status.total <= (this.status.processada + this.status.erro)) {

                  this.alertService.notificationSuccess(
                    "Recarga por arquivo",
                    "Dados processados",
                    options
                  );

                  this.processed = true;
                  this.sub.unsubscribe();

                  this.updateValues();
                }
              }
              else {
                this.sub.unsubscribe();
                this.alertService.error(response.message);
              }
            }, error => { console.log(error) }
          ) // load data contains the http request
      })
    ).subscribe();
  }

  updateValues() {
    this.valuesPurchase.purchaseId = this.purchaseId;
    this.valuesPurchase.products = [];
    this.pedidoService.UpdatePurchaseValues(this.valuesPurchase, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          console.log(response.message)
        } else {
          this.alertService.error(response.message);
        }
      }
    );
  }

  baixarErros() {
    this.pedidoService.getBatchErrors(this.id, this.currentUser.token.assignorGuid).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          saveAs(response.result, "Template-Recarga-Erro");
        } else {
          this.alertService.error(response.message);
        }
      }, error => { this.alertService.error(error.error); }
    );
  }

  continuar() {
    this.pedidoService.getPurchaseById(this.purchaseId, this.currentUser.token.assignorGuid, true).subscribe(
      response => {
        if (response.status === ApiError.Sucesso || (response.status === ApiError.Insucesso && response.result)) {

          response.result.managerGuid = this.currentUser.token.userReferenceId
          response.result.purchaseItens.forEach(pi => {
            pi.ehEditavel = true;
            pi.order.orderItens.forEach(oi => {
              oi.referenceValue = oi.providedValue;
            })
          });

          this.pedidoDataService.setCurrentPurchaseValue(response.result);
          this.router.navigate(['portal/novarecarga/selecaoperiodo']);

          if (response.status === ApiError.Insucesso)
            this.alertService.error(response.message);

        } else {
          this.router.navigate(['list'], { relativeTo: this.route.parent });
          this.alertService.error(response.message);
        }
      },
      error => { this.alertService.error(error); }
    );
    // this.router.navigate([`portal/minhasrecargas/details/${this.purchaseId}`]);
  }

  details() {
    // sessionStorage.setItem('currentPageC',this.currentPage.toString());
    sessionStorage.setItem('statusMinhasComprasList', this.StatusMinhasComprasList.ComprasEmAndamento.toString());
    this.router.navigate([`portal/minhasrecargas/details/${this.purchaseId}`]);
  }

  purchaseDetails() {
    /*this.pedidoService.getPurchaseById(this.purchaseId, this.currentUser.token.assignorGuid, true).subscribe(
      response => {
        if (response.status === ApiError.Sucesso || (response.status === ApiError.Insucesso && response.result)) {

          response.result.managerGuid = this.currentUser.token.userReferenceId
          response.result.purchaseItens.forEach(pi => {
            pi.ehEditavel = true;
            pi.order.orderItens.forEach(oi => {
              oi.referenceValue = oi.providedValue;
            })
          });

          this.pedidoDataService.setCurrentPurchaseValue(response.result);
          this.router.navigate(['selecaoperiodo'], { relativeTo: this.route.parent });

          if (response.status === ApiError.Insucesso)
            this.alertService.error(response.message);

        } else {
          this.router.navigate(['list'], { relativeTo: this.route.parent });
          this.alertService.error(response.message);
        }
      },
      error => { this.alertService.error(error); }
    );*/
    // this.router.navigate([`portal/minhasrecargas/details/${this.purchaseId}`]);
    sessionStorage.setItem('statusMinhasComprasList', this.StatusMinhasComprasList.ComprasEmRascunho.toString());
    this.router.navigate([`portal/minhasrecargas/list`]);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
